import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IHvDaten } from '../../models/hvdaten';
import { PopupService } from '../../service/popup.service';

@Component({
  selector: 'app-bewilligungsjahr-haus',
  templateUrl: './bewilligungsjahr-haus.component.html',
  styleUrls: ['./bewilligungsjahr-haus.component.scss']
})
export class BewilligungsjahrHausComponent implements OnInit {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  @Input()
  isWohnung: boolean;

  @Output()
  calculateRatePendingEvent = new EventEmitter<void>();

  constructor(public translateService: TranslateService, public popupService: PopupService) { }

  static createFormGroup(fb: UntypedFormBuilder) {
    return fb.group({
      bewilligungsjahrHaus: new UntypedFormControl('', [Validators.pattern('^[0-9]*$'), Validators.min(1800), Validators.max(new Date().getFullYear() + 1)])
    });
  }

  ngOnInit(): void {
    this.onValueChanged();
  }

  get bewilligungsjahrHaus() { return this.formGroup.get('bewilligungsjahrHaus'); }

  onValueChanged(): void {
    this.bewilligungsjahrHaus.valueChanges.subscribe(() => {
      this.calculateRatePendingEvent.emit();
    });
  }

  getBewilligungsjahrHaus(): IHvDaten {
    return {
      Bewilligungsjahr: this.bewilligungsjahrHaus.value
    } as IHvDaten;
  }

  setBewilligungsjahrHaus(daten: IHvDaten) {
    this.bewilligungsjahrHaus.setValue(daten.Bewilligungsjahr);
  }
}
